import { remoteUrl, urlWithParams } from "../../helpers/UrlHelpers";

const BASE_URL  = process.env.REACT_APP_CALLRECORDER_URL;
const DEFAULT_PARAMS  = { order_by: 'id', order: 'desc' };

function bundlesPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/bundles`, params);
}
function bundlePath(this: any, id: number) {
  return `/${this.basePath}/bundles/${id}`;
}

function phnSubscriptionPlansPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/phn_subscription_plans`, params);
}
function phnSubscriptionPlanPath(this: any, id: number) {
  return `/${this.basePath}/phn_subscription_plans/${id}`;
}

function smsPackagesPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/sms_packages`, params);
}
function smsPackagePath(this: any, id: number) {
  return `/${this.basePath}/sms_packages/${id}`;
}

function providersPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/providers`, params);
}
function providerPath(this: any, id: number) {
  return `/${this.basePath}/providers/${id}`;
}

function availablePhoneNumbersPath(this: any, params: object = {}) {
  return urlWithParams(`/${this.basePath}/available_phone_numbers`, params);
}

function phoneNumberPricesPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/phone_number_prices`, params);
}
function phoneNumberPricePath(this: any, id: number) {
  return `/${this.basePath}/phone_number_prices/${id}`;
}

function usersPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/users`, params);
}
function userPath(this: any, id: number) {
  return `/${this.basePath}/users/${id}`;
}

function userNumbersPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/user_numbers`, params);
}
function userNumberPath(this: any, id: number) {
  return `/${this.basePath}/user_numbers/${id}`;
}

function devicesPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/devices`, params);
}
function devicePath(this: any, id: number) {
  return `/${this.basePath}/devices/${id}`;
}

function ordersPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/orders`, params);
}
function orderPath(this: any, id: number) {
  return `/${this.basePath}/orders/${id}`;
}

function subscriptionsPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/subscriptions`, params);
}
function subscriptionPath(this: any, id: number) {
  return `/${this.basePath}/subscriptions/${id}`;
}

function userNumberSubscriptionsPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/user_number_subscriptions`, params);
}
function userNumberSubscriptionPath(this: any, id: number) {
  return `/${this.basePath}/user_number_subscriptions/${id}`;
}

function userNumberMessagesPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/user_number_messages`, params);
}
function userNumberMessagePath(this: any, id: number) {
  return `/${this.basePath}/user_number_messages/${id}`;
}

function cdrsPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/cdrs`, params);
}
function cdrPath(this: any, id: number) {
  return `/${this.basePath}/cdrs/${id}`;
}

function invoicesPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/invoices`, params);
}
function invoicePath(this: any, id: number) {
  return `/${this.basePath}/invoices/${id}`;
}

function coinLogsPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/coin_logs`, params);
}
function coinLogPath(this: any, id: number) {
  return `/${this.basePath}/coin_logs/${id}`;
}

function ratesPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/rates`, params);
}
function ratePath(this: any, id: number) {
  return `/${this.basePath}/rates/${id}`;
}

function csvImportsPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/csv_imports`, params);
}
function csvImportPath(this: any, id: number) {
  return `/${this.basePath}/csv_imports/${id}`;
}

const callrecorderUrls = {
  baseURL:        BASE_URL,
  basePath:       'callrecorder',
  remoteUrl:      remoteUrl,

  bundlesPath:    bundlesPath,
  bundlePath:     bundlePath,

  phnSubscriptionPlansPath:  phnSubscriptionPlansPath,
  phnSubscriptionPlanPath:   phnSubscriptionPlanPath,

  smsPackagesPath:  smsPackagesPath,
  smsPackagePath:   smsPackagePath,

  providersPath:  providersPath,
  providerPath:   providerPath,

  ratesPath:  ratesPath,
  ratePath:   ratePath,

  csvImportsPath:  csvImportsPath,
  csvImportPath:   csvImportPath,

  availablePhoneNumbersPath:  availablePhoneNumbersPath,

  phoneNumberPricesPath:  phoneNumberPricesPath,
  phoneNumberPricePath:   phoneNumberPricePath,

  usersPath:  usersPath,
  userPath:   userPath,

  userNumbersPath:  userNumbersPath,
  userNumberPath:   userNumberPath,

  devicesPath:  devicesPath,
  devicePath:   devicePath,

  ordersPath:  ordersPath,
  orderPath:   orderPath,

  subscriptionsPath:  subscriptionsPath,
  subscriptionPath:   subscriptionPath,

  userNumberSubscriptionsPath:  userNumberSubscriptionsPath,
  userNumberSubscriptionPath:   userNumberSubscriptionPath,

  userNumberMessagesPath:  userNumberMessagesPath,
  userNumberMessagePath:   userNumberMessagePath,

  cdrsPath:  cdrsPath,
  cdrPath:   cdrPath,

  invoicesPath:  invoicesPath,
  invoicePath:   invoicePath,

  coinLogsPath:  coinLogsPath,
  coinLogPath:   coinLogPath,
}

export default callrecorderUrls;
